import { composeValidators } from 'revalidate';
import { isObject, isString, isRequiredString } from 'Utils/validators';
import { translationStringsValidator } from './translationValidator';

const imprintConfigValidator = (defaultLanguage) => ({
  company: isString('company'),
  address: isString('address'),
  phone: isString('phone'),
  email: isRequiredString('email'),
  customHtmlSourcePath: composeValidators(
    isObject(''),
    translationStringsValidator(defaultLanguage)
  )('customHtmlSourcePath')
});

export default imprintConfigValidator;
